import {
  START_GET_PATIENT_LIST,
  SUCCESS_GET_PATIENT_LIST,
  ERROR_GET_PATIENT_LIST,
  RESET_PATIENT_STATE,
  START_CREATE_PATIENT,
  SUCCESS_CREATE_PATIENT,
  ERROR_CREATE_PATIENT,
  START_UPDATE_PATIENT,
  SUCCESS_UPDATE_PATIENT,
  ERROR_UPDATE_PATIENT,
  START_GET_SINGLE_PATIENT,
  SUCCESS_GET_SINGLE_PATIENT,
  ERROR_GET_SINGLE_PATIENT,
  START_DELETE_PATIENT,
  SUCCESS_DELETE_PATIENT,
  ERROR_DELETE_PATIENT,
  START_GET_SURGERY_FIELD_LIST,
  SUCCESS_GET_SURGERY_FIELD_LIST,
  ERROR_GET_SURGERY_FIELD_LIST,
  START_PHARMACY_LIST,
  SUCCESS_PHARMACY_LIST,
  ERROR_PHARMACY_LIST,
  START_DRUG_LIST,
  SUCCESS_DRUG_LIST,
  ERROR_GURG_LIST,
  START_GROUP_FIELD_LIST,
  SUCCESS_GROUP_FIELD_LIST,
  ERROR_GROUP_FIELD_LIST,
  START_PATIENT_URGENCY_STATUS_CHANGE,
  SUCCESS_PATIENT_URGENCY_STATUS_CHANGE,
  ERROR_PATIENT_URGENCY_STATUS_CHANGE,
  START_CREATE_PATIENT_NOTE,
  SUCCESS_CREATE_PATIENT_NOTE,
  ERROR_CREATE_PATIENT_NOTE,
  START_UPDATE_PATIENT_NOTE,
  SUCCESS_UPDATE_PATIENT_NOTE,
  ERROR_UPDATE_PATIENT_NOTE,
  START_DELETE_PATIENT_NOTE,
  SUCCESS_DELETE_PATIENT_NOTE,
  ERROR_DELETE_PATIENT_NOTE,
  START_GET_PATIENT_NOTE_LIST,
  SUCCESS_GET_PATIENT_NOTE_LIST,
  ERROR_GET_PATIENT_NOTE_LIST,
  START_GET_SINGLE_PATIENT_NOTE,
  SUCCESS_GET_SINGLE_PATIENT_NOTE,
  ERROR_GET_SINGLE_PATIENT_NOTE,
  START_GET_PATIENT_MEDICATION_HISTORY_LIST,
  SUCCESS_GET_PATIENT_MEDICATION_HISTORY_LIST,
  ERROR_GET_PATIENT_MEDICATION_HISTORY_LIST,
  START_CREATE_PATIENT_SURGERY,
  SUCCESS_CREATE_PATIENT_SURGERY,
  ERROR_CREATE_PATIENT_SURGERY,
  START_IMPORT_CSV,
  SUCCESS_IMPORT_CSV,
  ERROR_IMPORT_CSV,
  START_GET_IMPORT_CSV_LIST,
  SUCCESS_GET_IMPORT_CSV_LIST,
  ERROR_GET_IMPORT_CSV_LIST,
  START_DELETE_MULTIPLE_AND_SINGLE_CSV,
  SUCCESS_DELETE_MULTIPLE_AND_SINGLE_CSV,
  ERROR_DELETE_MULTIPLE_AND_SINGLE_CSV,
  START_STATUS_PATIENT_UPDATE,
  SUCCESS_STATUS_PATIENT_UPDATE,
  ERROR_STATUS_PATIENT_UPDATE,
  START_UPDATE_FIELD_PATIENT,
  SUCCESS_UPDATE_FIELD_PATIENT,
  ERROR_UPDATE_FIELD_PATIENT,
  START_ARCHIVE_MEDICATION,
  SUCCESS_ARCHIVE_MEDICATION,
  ERROR_ARCHIVE_MEDICATION,
  START_PROFILE_UPDATE,
  SUCCESS_PROFILE_UPDATE,
  ERROR_PROFILE_UPDATE,
  START_PATIENT_MULTI_DELETE,
  SUCCESS_PATIENT_MULTI_DELETE,
  ERROR_PATIENT_MULTI_DELETE,
  START_GET_IMPORT_PATIENT_DUPLICATE,
  SUCCESS_GET_IMPORT_PATIENT_DUPLICATE,
  ERROR_GET_IMPORT_PATIENT_DUPLICATE,
  START_IMPORT_PATIENT_DUPLICATE_DELETE,
  SUCCESS_IMPORT_PATIENT_DUPLICATE_DELETE,
  ERROR_IMPORT_PATIENT_DUPLICATE_DELETE,
  START_PATIENT_ALL_DELETE,
  SUCCESS_PATIENT_ALL_DELETE,
  ERROR_PATIENT_ALL_DELETE,
} from "Actions/PatientAction";

const initialState = {
  patientList: {
    loading: false,
    data: {},
    error: "",
  },
  createPatientSurgeryData: {
    loading: false,
    data: {},
    error: {},
  },
  createPatientData: {
    loading: false,
    data: {},
    error: {},
  },
  updatePatientData: {
    loading: false,
    data: {},
    error: {},
  },
  singlePatientData: {
    loading: false,
    data: {},
    error: {},
    isRecordFound: true,
  },
  deletePatientData: {
    loading: false,
    data: {},
    error: {},
  },
  surgeryFieldList: {
    loading: false,
    data: {},
    error: {},
  },
  pharmacyList: {
    loading: false,
    data: {},
    error: {},
  },
  drugFieldList: {
    loading: false,
    data: {},
    error: {},
  },
  groupFieldList: {
    loading: false,
    data: {},
    error: {},
  },
  updatePatientStatusData: {
    loading: false,
    data: {},
    error: {},
  },
  patientNoteList: {
    loading: false,
    data: {},
    error: {},
  },
  createPatientNoteData: {
    loading: false,
    data: {},
    error: {},
  },
  updatePatientNoteData: {
    loading: false,
    data: {},
    error: {},
  },
  deletePatientNoteData: {
    loading: false,
    data: {},
    error: {},
  },
  singlePatientNoteData: {
    loading: false,
    data: {},
    error: {},
    isRecordFound: true,
  },
  patientMedicationHistoryList: {
    loading: false,
    data: {},
    error: "",
  },
  countPatient: {
    loading: false,
    data: {},
    error: "",
  },
  importPatientCsv: {
    loading: false,
    data: [],
    error: {},
  },
  importCsvListData: {
    loading: false,
    data: {},
    error: {},
  },
  deleteMultipleAndSingleCsvData: {
    loading: false,
    data: [],
    error: {},
  },
  statusUpdate: {
    loading: false,
    data: {},
    error: {},
  },
  archiveMedi: {
    loading: false,
    data: {},
    error: {},
  },
  profileUpdate: {
    loading: false,
    data: {},
    error: {},
  },
  importduplicatePatient: {
    loading: false,
    data: {},
    error: {},
  },
  deleteDuplicatePatientData: {
    loading: false,
    data: {},
    error: {},
  },
  deleteAllPatientData: {
    loading: false,
    data: {},
    error: {},
  },
};

export const PatientReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PATIENT_STATE: {
      return {
        ...state,
        [action.key]: action?.payload || initialState[action.key],
      };
    }
    case START_GET_PATIENT_LIST: {
      let oldList = state?.patientList?.data;
      return {
        ...state,
        patientList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_PATIENT_LIST: {
      let oldList = state?.patientList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        patientList: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_PATIENT_LIST: {
      return {
        ...state,
        patientList: {
          loading: false,
          data: {},
          error: "",
        },
      };
    }
    case START_CREATE_PATIENT: {
      return {
        ...state,
        createPatientData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_PATIENT: {
      return {
        ...state,
        createPatientData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_PATIENT: {
      return {
        ...state,
        createPatientData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_PATIENT: {
      return {
        ...state,
        updatePatientData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_PATIENT: {
      let oldList = state?.patientList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        updatePatientData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_PATIENT: {
      return {
        ...state,
        updatePatientData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_FIELD_PATIENT: {
      return {
        ...state,
        updatePatientData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_FIELD_PATIENT: {
      let oldList = state?.patientList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        updatePatientData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_FIELD_PATIENT: {
      return {
        ...state,
        updatePatientData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_SINGLE_PATIENT: {
      let oldList = state?.singlePatientData?.data;
      return {
        ...state,
        singlePatientData: {
          loading: true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
          isRecordFound: true,
        },
      };
    }
    case SUCCESS_GET_SINGLE_PATIENT: {
      let oldList = state?.singlePatientData?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        singlePatientData: {
          loading: false,
          data: oldList,
          error: {},
          isRecordFound: true,
        },
      };
    }
    case ERROR_GET_SINGLE_PATIENT: {
      return {
        ...state,
        singlePatientData: {
          loading: false,
          data: {},
          error: action.payload.errors,
          isRecordFound: false,
        },
      };
    }
    case START_DELETE_PATIENT: {
      return {
        ...state,
        deletePatientData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_PATIENT: {
      let oldList = state?.patientList?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      oldList.urgent_count = oldList?.urgent_count - 1;
      return {
        ...state,
        deletePatientData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DELETE_PATIENT: {
      return {
        ...state,
        deletePatientData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_SURGERY_FIELD_LIST: {
      let oldList = state?.surgeryFieldList?.data;
      return {
        ...state,
        surgeryFieldList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GET_SURGERY_FIELD_LIST: {
      let oldList = state?.surgeryFieldList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        surgeryFieldList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_SURGERY_FIELD_LIST: {
      return {
        ...state,
        surgeryFieldList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_PHARMACY_LIST: {
      let oldList = state?.pharmacyList?.data;
      return {
        ...state,
        pharmacyList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_PHARMACY_LIST: {
      let oldList = state?.pharmacyList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        pharmacyList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_PHARMACY_LIST: {
      return {
        ...state,
        pharmacyList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DRUG_LIST: {
      let oldList = state?.drugFieldList?.data;
      return {
        ...state,
        drugFieldList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: oldList,
          error: {},
        },
      };
    }
    case SUCCESS_DRUG_LIST: {
      // let oldList = state?.drugFieldList?.data;
      // if (action.page > 1) {
      //   oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      // } else {
      //   oldList = {
      //     list: action?.payload?.data?.list,
      //     total: action?.payload?.data?.pagination.totalCount,
      //   };
      // }
      let oldList = state?.drugFieldList?.data;
      if (action.page > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = {
          list: action?.payload?.data?.list,
          total: action?.payload?.data?.total,
        };
      }
      return {
        ...state,
        drugFieldList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GURG_LIST: {
      return {
        ...state,
        drugFieldList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GROUP_FIELD_LIST: {
      let oldList = state?.groupFieldList?.data;
      return {
        ...state,
        groupFieldList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }
    case SUCCESS_GROUP_FIELD_LIST: {
      let oldList = state?.groupFieldList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        groupFieldList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GROUP_FIELD_LIST: {
      return {
        ...state,
        groupFieldList: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_PATIENT_URGENCY_STATUS_CHANGE: {
      return {
        ...state,
        updatePatientStatusData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_PATIENT_URGENCY_STATUS_CHANGE: {
      return {
        ...state,
        updatePatientStatusData: {
          loading: false,
          data: action.payload,
          error: "",
        },
      };
    }
    case ERROR_PATIENT_URGENCY_STATUS_CHANGE: {
      return {
        ...state,
        updatePatientStatusData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_PATIENT_NOTE_LIST: {
      let oldList = state?.patientNoteList?.data;
      return {
        ...state,
        patientNoteList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_PATIENT_NOTE_LIST: {
      let oldList = state?.patientNoteList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        patientNoteList: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_PATIENT_NOTE_LIST: {
      return {
        ...state,
        patientNoteList: {
          loading: false,
          data: {},
          error: "",
        },
      };
    }
    case START_CREATE_PATIENT_NOTE: {
      return {
        ...state,
        createPatientNoteData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_PATIENT_NOTE: {
      let oldList = state?.patientNoteList?.data;
      let newNote = action?.payload?.data;
      let newNoteList = oldList?.list ? [newNote, ...oldList.list] : [newNote];
      return {
        ...state,
        patientNoteList: {
          ...state.patientNoteList,
          data: {
            ...oldList,
            list: newNoteList,
            filterd_record: (oldList?.filterd_record || 0) + 1,
            total: (oldList?.total || 0) + 1,
          },
        },
        createPatientNoteData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_PATIENT_NOTE: {
      return {
        ...state,
        createPatientNoteData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_UPDATE_PATIENT_NOTE: {
      return {
        ...state,
        updatePatientNoteData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_UPDATE_PATIENT_NOTE: {
      let oldList = state?.patientNoteList?.data;
      let newNoteList = oldList?.list?.map((item) => {
        if (item?.id == action?.id) {
          return {
            ...item,
            ...action?.payload?.data,
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        patientNoteList: {
          ...state.patientNoteList,
          data: {
            ...oldList,
            list: newNoteList,
          },
        },
        updatePatientNoteData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_UPDATE_PATIENT_NOTE: {
      return {
        ...state,
        updatePatientNoteData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_DELETE_PATIENT_NOTE: {
      return {
        ...state,
        deletePatientNoteData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_PATIENT_NOTE: {
      let oldList = state?.patientNoteList?.data;
      let newNoteList = oldList?.list?.filter((item) => item?.id != action?.id);
      return {
        ...state,
        patientNoteList: {
          ...state.patientNoteList,
          data: {
            ...oldList,
            list: newNoteList,
            filterd_record: Math.max(0, (oldList?.filterd_record || 1) - 1),
            total: Math.max(0, (oldList?.total || 1) - 1),
          },
        },
        deletePatientNoteData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DELETE_PATIENT_NOTE: {
      return {
        ...state,
        deletePatientNoteData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_SINGLE_PATIENT_NOTE: {
      let oldList = state?.singlePatientNoteData?.data;
      return {
        ...state,
        singlePatientNoteData: {
          loading: true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
          isRecordFound: true,
        },
      };
    }
    case SUCCESS_GET_SINGLE_PATIENT_NOTE: {
      let oldList = state?.singlePatientNoteData?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        singlePatientNoteData: {
          loading: false,
          data: oldList,
          error: {},
          isRecordFound: true,
        },
      };
    }
    case ERROR_GET_SINGLE_PATIENT_NOTE: {
      return {
        ...state,
        singlePatientNoteData: {
          loading: false,
          data: {},
          error: action.payload.errors,
          isRecordFound: false,
        },
      };
    }
    case START_GET_PATIENT_MEDICATION_HISTORY_LIST: {
      let oldList = state?.patientMedicationHistoryList?.data;
      return {
        ...state,
        patientMedicationHistoryList: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: {},
        },
      };
    }

    case SUCCESS_GET_PATIENT_MEDICATION_HISTORY_LIST: {
      let oldList = state?.patientMedicationHistoryList?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }

      return {
        ...state,
        patientMedicationHistoryList: {
          loading: false,
          data: oldList,
          error: {},
        },
      };
    }
    case ERROR_GET_PATIENT_MEDICATION_HISTORY_LIST: {
      return {
        ...state,
        patientMedicationHistoryList: {
          loading: false,
          data: {},
          error: {},
        },
      };
    }
    case START_CREATE_PATIENT_SURGERY: {
      return {
        ...state,
        createPatientSurgeryData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_CREATE_PATIENT_SURGERY: {
      return {
        ...state,
        createPatientSurgeryData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_CREATE_PATIENT_SURGERY: {
      return {
        ...state,
        createPatientSurgeryData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_STATUS_PATIENT_UPDATE: {
      return {
        ...state,
        statusUpdate: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_STATUS_PATIENT_UPDATE: {
      let oldList = state?.patientList?.data;
      oldList.list = oldList?.list?.map((item) => {
        if (action?.update_type == "repeatorder") {
          if (item.id === action.payload.data.id) {
            return {
              ...item,
              status: action?.status,
            };
          }
        } else {
          if (item.id === action.payload.data.id) {
            item.status = action?.payload?.data?.status;
            return {
              ...item,
              status: action?.payload?.data?.status,
            };
          }
        }
        return item;
      });
      return {
        ...state,
        patientList: {
          loading: false,
          data: oldList,
          error: "",
        },
        statusUpdate: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_STATUS_PATIENT_UPDATE: {
      return {
        ...state,
        statusUpdate: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_IMPORT_CSV: {
      return {
        ...state,
        importPatientCsv: {
          loading: true,
          data: [],
          error: {},
        },
      };
    }
    case SUCCESS_IMPORT_CSV: {
      return {
        ...state,
        importPatientCsv: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_IMPORT_CSV: {
      return {
        ...state,
        importPatientCsv: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    }
    case START_GET_IMPORT_CSV_LIST: {
      let oldList = state?.importCsvListData?.data;
      return {
        ...state,
        importCsvListData: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_IMPORT_CSV_LIST: {
      let oldList = state?.importCsvListData?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        importCsvListData: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_IMPORT_CSV_LIST: {
      return {
        ...state,
        importCsvListData: {
          loading: false,
          data: {},
          error: "",
        },
      };
    }
    case START_DELETE_MULTIPLE_AND_SINGLE_CSV: {
      return {
        ...state,
        deleteMultipleAndSingleCsvData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_DELETE_MULTIPLE_AND_SINGLE_CSV: {
      let oldList = state?.importCsvListData?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        deleteMultipleAndSingleCsvData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_DELETE_MULTIPLE_AND_SINGLE_CSV: {
      return {
        ...state,
        deleteMultipleAndSingleCsvData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_ARCHIVE_MEDICATION: {
      return {
        ...state,
        archiveMedi: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_ARCHIVE_MEDICATION: {
      // let oldList = state?.patientMedicationHistoryList?.data;
      // oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      // oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        archiveMedi: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_ARCHIVE_MEDICATION: {
      return {
        ...state,
        archiveMedi: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }

    case START_PROFILE_UPDATE: {
      return {
        ...state,
        profileUpdate: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_PROFILE_UPDATE: {
      return {
        ...state,
        profileUpdate: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_PROFILE_UPDATE: {
      return {
        ...state,
        profileUpdate: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_PATIENT_MULTI_DELETE: {
      return {
        ...state,
        deleteMultipleAndSingleCsvData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_PATIENT_MULTI_DELETE: {
      let oldList = state?.patientList?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        deleteMultipleAndSingleCsvData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_PATIENT_MULTI_DELETE: {
      return {
        ...state,
        deleteMultipleAndSingleCsvData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_GET_IMPORT_PATIENT_DUPLICATE: {
      let oldList = state?.importduplicatePatient?.data;
      return {
        ...state,
        importduplicatePatient: {
          loading: action?.payload?.offset > 0 ? false : true,
          data: action?.payload?.offset > 0 ? oldList : {},
          error: "",
        },
      };
    }
    case SUCCESS_GET_IMPORT_PATIENT_DUPLICATE: {
      let oldList = state?.importduplicatePatient?.data;
      if (oldList?.list?.length > 0) {
        oldList.list = [...oldList?.list, ...action?.payload?.data?.list];
      } else {
        oldList = action?.payload?.data;
      }
      return {
        ...state,
        importduplicatePatient: {
          loading: false,
          data: oldList,
          error: "",
        },
      };
    }
    case ERROR_GET_IMPORT_PATIENT_DUPLICATE: {
      return {
        ...state,
        importduplicatePatient: {
          loading: false,
          data: {},
          error: "",
        },
      };
    }
    case START_IMPORT_PATIENT_DUPLICATE_DELETE: {
      return {
        ...state,
        deleteDuplicatePatientData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_IMPORT_PATIENT_DUPLICATE_DELETE: {
      let oldList = state?.importduplicatePatient?.data;
      oldList.list = oldList?.list?.filter((item) => item?.id != action?.id);
      oldList.filterd_record = oldList?.filterd_record - 1;
      return {
        ...state,
        deleteDuplicatePatientData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_IMPORT_PATIENT_DUPLICATE_DELETE: {
      return {
        ...state,
        deleteDuplicatePatientData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }
    case START_PATIENT_ALL_DELETE: {
      return {
        ...state,
        deleteAllPatientData: {
          loading: true,
          data: {},
          error: {},
        },
      };
    }
    case SUCCESS_PATIENT_ALL_DELETE: {
      return {
        ...state,
        deleteAllPatientData: {
          loading: false,
          data: action.payload,
          error: {},
        },
      };
    }
    case ERROR_PATIENT_ALL_DELETE: {
      return {
        ...state,
        deleteAllPatientData: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    }

    default: {
      return state || initialState;
    }
  }
};
